// extracted by mini-css-extract-plugin
export default {"container":"D-1sA___Input-module__container","label":"DwjUO___Input-module__label","input":"_4RccY___Input-module__input"};